import script from "./FontAwesomeIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=ts&setup=true"

import "./FontAwesomeIcon.vue?vue&type=style&index=0&id=008bfe74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008bfe74"]])

export default __exports__